import React, { useState } from "react";
import "./ExecutionAndDocumentationDesktopView.css";
import ExecutionAndDocumentationDesktopStep2 from "./ExecutionAndDocumentationDesktopStep2";
import ExecutionAndDocumentationDesktopStep1 from "./ExecutionAndDocumentationDesktopStep1";
import ExecutionAndDocumentationDesktopStep3 from "./ExecutionAndDocumentationDesktopStep3";
import ExecutionAndDocumentationDesktopStep4 from "./ExecutionAndDocumentationDesktopStep4";
import ExecutionAndDocumentationDesktopStep5 from "./ExecutionAndDocumentationDesktopStep5";
import { useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import CryptoJS from "crypto-js";
import search from "../../../images/Search.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";

function ExecutionAndDocumentationDesktopView() {
  const steps = [1, 2, 3, 4, 5];
  const [orderRelocation, setOrderRelocation] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);

    getDocument();

    const storedToken = JSON.parse(localStorage.getItem("accessToken"));

    if (storedToken) {
      axios
        .get(
          `${baseAPI}customerget/GetCustomerOrderSummary?relocation_id=` +
            Relocation_ID,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setOrderRelocation(response.data.data[0]);
          
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  const [rows, setRows] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);
  const baseAPI = process.env.REACT_APP_API_URL;
  const baseImageURL = process.env.REACT_APP_IMAGE_URL;
  const location = useLocation();
  const [documentResponse, setDocumentResponse] = useState(null);

  const handleNext = () => {
    if (currentStep < steps.length) setCurrentStep(currentStep + 1);
  };

  const handlePrev = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

  const searchParams = new URLSearchParams(location.search);
  const encryptedRelocationID = searchParams.get("ID");
  const Relocation_ID = decryptRelocationID(encryptedRelocationID);

  function decryptRelocationID(ciphertext) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        decodeURIComponent(ciphertext),
        "dbbworldwidepvtltd"
      );
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error decrypting Relocation_ID:", error);

      return null;
    }
  }

  function getDocument() {
    const storedToken = JSON.parse(localStorage.getItem("accessToken"));
    if (storedToken) {
      axios
        .get(
          `${baseAPI}customerget/GetCustomerDocumentsDetail?relocation_id=` +
            Relocation_ID +
            `&option=1&is_submit=1&documentTypeId=0`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          if (response) {
            setDocumentResponse(response.data.data);
            const data = response.data?.data || [];
            setRows(data);
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  const formatDate = (dateString) => {
    const options = {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };

    const formattedDate = new Date(dateString).toLocaleString("en-US", options);
    return formattedDate;
  };

  // Styles
  const rowColorChange = (index) => ({
    backgroundColor: index % 2 === 0 ? "#f6f3ff" : "white",
    color: "black",
  });

  return (
    <div className="main px-3 py-4">
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "8px",
          boxShadow:
            "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
          backgroundColor: "white",
        }}
        className="container-fluid p-4"
      >
        <h1 className="heading mb-4">Execution & Documentation</h1>
        <div
          className="container-fluid px-0"
          style={{ backgroundColor: "#F6F3FF" }}
        >
          <div
            style={{ padding: "5px", paddingLeft: "14px", paddingTop: "16px" }}
          >
            <h6 style={{ color: "#5B489D", fontWeight: "700" }}>NOTE</h6>
            <p
              style={{
                fontStyle: "italic",
                fontSize: "16px",
                fontWeight: "700",
              }}
            >
              *Kindly preview your uploaded documents before submitting them.
              Documents you have submitted cannot be deleted, edited, or altered
              by you once uploaded. If any changes are required, you will have
              to request those changes from the operations team for correction
              or editing.{" "}
            </p>
          </div>
        </div>
        <br />
        <div className="container-fluid px-0" style={{ borderRadius: "8px" }}>
          <div
            style={{
              border: "2px solid #D9D9D9",
              borderRadius: "8px",
              width: "100%",
            }}
            className="d-flex justify-content-start align-items-start p-2"
          >
            <h4
              style={{
                marginLeft: "4px",
                fontSize: "20px",
                fontWeight: "bold",
                padding: "8px 0px 0px 1px",
                color: "#6a6a6a",
                borderBottom: "4px solid #5B489D",
              }}
            >
              STEP{" "}
              {currentStep === 1
                ? 1
                : currentStep === 2
                ? 2
                : currentStep === 3
                ? 3
                : currentStep === 4
                ? 4
                : 5}
            </h4>
          </div>
        </div>
        <div className="exec-top-circle-main container-fluid mt-4">
          <div className="progress-bar">
            <div
              className="progress-line"
              style={{
                width: `${((currentStep - 1) / (steps.length - 1)) * 100}%`,
              }}
            ></div>

            {steps.map((step, index) => (
              <div key={step} className="step-container">
                <div
                  className={`step-number ${
                    index + 1 <= currentStep ? "active" : ""
                  }`}
                >
                  {`0${step}`}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* STEPS DETAILS  */}
        <div>
          {currentStep === 1 ? (
            <ExecutionAndDocumentationDesktopStep1
              // setActiveExecutionStep={setActiveExecutionStep}
              getDocument={getDocument}
              documentResponse={documentResponse}
            />
          ) : currentStep === 2 ? (
            <ExecutionAndDocumentationDesktopStep2
              // setActiveExecutionStep={setActiveExecutionStep}
              getDocument={getDocument}
              documentResponse={documentResponse}
            />
          ) : currentStep === 3 ? (
            <ExecutionAndDocumentationDesktopStep3
              // setActiveExecutionStep={setActiveExecutionStep}
              getDocument={getDocument}
              documentResponse={documentResponse}
            />
          ) : currentStep === 4 ? (
            <ExecutionAndDocumentationDesktopStep4
              // setActiveExecutionStep={setActiveExecutionStep}
              getDocument={getDocument}
              documentResponse={documentResponse}
            />
          ) : currentStep === 5 ? (
            <ExecutionAndDocumentationDesktopStep5
              getDocument={getDocument}
              documentResponse={documentResponse}
            />
          ) : null}
        </div>
        {/* bar code button */}
        <div className="buttons" style={{ textAlign: "end" }}>
          <button onClick={handlePrev} disabled={currentStep === 1}>
            Previous
          </button>
          <button onClick={handleNext} disabled={currentStep === steps.length}>
            Next
          </button>
        </div>

        <h1 className="heading mb-4">Documents</h1>
        <div className="row" style={{ paddingBottom: "12px" }}>
          <div
            className="col-md-3"
            style={{ textAlign: "left", backgroundColor: "#f6f3ff" }}
          >
            <div style={{ height: "36.4px", padding: "5px" }}>
              <span>Sales Co-ordinator</span>
            </div>
          </div>
          <div className="col-md-3">
            <div style={{ height: "36.4px", padding: "5px" }}>
              <span>{orderRelocation.Name}</span>
            </div>
          </div>

          <div
            className="col-md-3"
            style={{ textAlign: "left", backgroundColor: "#f6f3ff" }}
          >
            <div style={{ height: "36.4px", padding: "5px" }}>
              <span>Operations Co-ordinator</span>
            </div>
          </div>
          <div className="col-md-3">
            <div style={{ height: "36.4px", padding: "5px" }}>
              <span>{orderRelocation.Assigned_By_Coordinator}</span>
            </div>
          </div>
        </div>

        <table className="table">
          <thead>
            <tr className="scop_of_work_tr_th">
              <th>S.No</th>
              <th>Document Type</th>
              <th>Upload Date & Time</th>
              <th>Uploaded By</th>
              <th>Status</th>
              <th>Remark</th>
              <th>Action</th>
            </tr>
          </thead>
          <hr
            style={{ background: "white", height: "0px", color: "white" }}
          ></hr>
          <tbody>
            {Array.isArray(rows) &&
              rows.map((row, index) => (
                <tr key={row.Temp_ID} style={rowColorChange(index)}>
                  <td style={rowColorChange(index)}>
                    {String(index + 1).padStart(2, "0")}
                  </td>
                  <td style={rowColorChange(index)}>{row.DocumentTypeName}</td>
                  <td style={rowColorChange(index)}>
                    {formatDate(row.createdDate)}
                  </td>
                  <td style={rowColorChange(index)}>{row.createdBy}</td>
                  <td style={rowColorChange(index)}>
                    {row.is_verified === 0 ? (
                      <span
                        style={{
                          color: "red",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faTimes} // Cross icon
                          style={{ marginRight: "8px" }}
                        />
                        Not Verified
                      </span>
                    ) : (
                      <span
                        style={{
                          color: "green",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faCheck} // Check icon
                          style={{ marginRight: "8px" }}
                        />
                        Verified
                      </span>
                    )}
                  </td>
                  <td style={rowColorChange(index)}>{row.remark}</td>
                  <td style={rowColorChange(index)}>
                    <a
                      style={{
                        color: "#6a6a6a",
                        textDecoration: "none",
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                      target="_blank"
                      href={`${baseImageURL}Images/Documents/${row.relocation_id}/${row.doc_name}`}
                      rel="noopener noreferrer"
                    >
                      <img src={search} alt="search" />
                    </a>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        {/* bar code end  */}
      </div>
    </div>
  );
}

export default ExecutionAndDocumentationDesktopView;
